import { formatNumber } from '@eika-infrastruktur/format';

export const toKebabCase = (str: string): string =>
    str
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .replace(/[^a-zA-Z0-9-]+/g, '-') // replace non-alphanumeric (except dash) with dash
        .replace(/-+/g, '-') // collapse multiple dashes
        .replace(/^-|-$/g, '') // trim leading/trailing dash
        .toLowerCase();

export const replaceNorwegianChars = (str: string): string =>
    str
        .replace(/æ/gi, (m) => (m === 'Æ' ? 'Ae' : 'ae'))
        .replace(/ø/gi, (m) => (m === 'Ø' ? 'Oe' : 'oe'))
        .replace(/å/gi, (m) => (m === 'Å' ? 'Aa' : 'aa'));

export const formatNok = (amount: number) => withKrSuffix(formatNumber(amount, 0));

const withKrSuffix = (value: string) => `${value} kr`;
